import React,{useEffect,useState} from 'react'
import { useAuthContext } from '../../context/Auth/Create'
import { assetUrl } from '../../helpers';
import { Dashboard } from '../../sdk'
import { Loader } from '../Default';

export function OccupancyPage() {
  const [state,setState]=useState({loader:true,data:[]});
  const userAuth=useAuthContext();
  const realimeData=async()=>{
  try{
    let result=await new Dashboard().statistics();
    setState((pre)=>{
      return {...pre,...result,loader:false};
    })
}catch(e){
console.log(e);
}
  }
  useEffect(()=>{
	  realimeData()
	  const setTime=setInterval(()=>realimeData(),1000 *1)
	  return ()=>{
		clearInterval(setTime)
	  }
	  },[])
   if(state.loader)  return <Loader/>;
  return (
    <div id="app" className="">
  
    <div className="container">
           <div className="row justify-content-center">
      
        <div className="col-xl-12">
          {/* BEGIN row */}
          <div className="row">
            {/* BEGIN col-9 */}
            <div className="col-xl-12">
              <div id="hoverableRows" className="mb-5">
                <h4>Live Data</h4>
               
                <div className="card">
                  <div className="card-body">
                  <div className="table mb-0" style={{textAlign:"center"}}>
                          <h1>{state.occupancy} <span style={{fontSize:'16px'}}>live Occupancy</span></h1>
                    </div>
                    <table className="table table-hover table-bordered mb-0" style={{textAlign:"center"}}>
                      <thead>
                        <tr>
                          <th scope="col"><h1>{state.footFall} <span style={{fontSize:'16px'}}>People In</span></h1></th>
                          <th scope="col"><h1>{state.totalExit} <span style={{fontSize:'16px'}}>People Out</span></h1></th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div className="card-arrow">
                    <div className="card-arrow-top-left" />
                    <div className="card-arrow-top-right" />
                    <div className="card-arrow-bottom-left" />
                    <div className="card-arrow-bottom-right" />
                  </div>
               
                </div>
              </div>
            </div>
            {/* END row */}
          </div>
          {/* END col-10 */}
        </div>
        {/* END row */}
      </div>
      {/* END container */}
    </div>
  </div>
  

  )
}
